module.exports = __webpack_public_path__ + "img/shopping.ba67f829.svg";